export const appSearchResSorting = () => {
    const toggleSortingDropdown = (dropdown) => {
        const input = dropdown.find(".js-sr-sorting-dd");
        const menu = dropdown.find(".sorting-dd-menu");
        const options = dropdown.find(".sorting-dd-option a");
        const isOpen = dropdown.attr("data-state") === "expanded";

        if (isOpen) {
            // Set attributes for closed state
            dropdown.attr("data-state", "placeholder");
            menu.attr("aria-hidden", "true");
            options.attr("tabindex", "-1");
        } else {
            // Set attributes for open state
            dropdown.attr("data-state", "expanded");
            menu.attr("aria-hidden", "false");
            options.attr("tabindex", "0");
        }
    };

    // Toggle sorting dropdown on click or Enter key press
    $(document).on("click", ".js-sr-sorting-dd", function (event) {
        const currentDropdown = $(this).closest(".js-sr-sorting-dropdown");
        toggleSortingDropdown(currentDropdown);
        event.preventDefault();
    });

    const closeDropdownOnEvent = (event) => {
        $('.js-sr-sorting-dropdown[data-state="expanded"]').each(function () {
            if (
                !$(this).is(event.target) &&
                !$(this).has(event.target).length
            ) {
                toggleSortingDropdown($(this)); // close the dropdown
            }
        });
    };

    // Close the dropdown when clicking outside or focusing away
    $(document).on("click focusin", closeDropdownOnEvent);
};
